import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListShows from '../../components/content/list-shows.component';

const ContentShowsView = () => {
  const pageTitle = `${PAGE_TITLE_LIST.CONTENT_SHOW}`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListShows />
    </AppLayout>
  );
};

export default ContentShowsView;
